import basicOptions from '@/router/basic-options';
import { pageAuthorization } from '@/router-middleware';
import { userPermission } from '@/constants';
import BaromoneyReport from '@/views/BaromoneyReport/index.vue';
import { routeName } from '@/constants/routeName';
export default [
    {
        path: 'baromoney-report',
        name: routeName.BAROMONEY_REPORT,
        component: BaromoneyReport,
        redirect: {
            name: routeName.BAROMONEY_REPORT_BASIC,
        },
        children: [
            {
                path: 'basic',
                name: routeName.BAROMONEY_REPORT_BASIC,
                component: () => import('@/views/BaromoneyReport/Basic/index.vue'),
                meta: {
                    ...basicOptions,
                    breadcrumbsItems: basicOptions.breadcrumbsItems.baromoneyReport.basic,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_HUB_SALES,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
        ],
    },
];
